import styled from 'styled-components';
import DropdownList from 'react-widgets/lib/DropdownList';
import whiteCheckMark from 'assets/images/check-mark-white.svg';
import 'react-dropdown/style.css';

export const DropdownBlock = styled.div`
  margin-bottom: 20px;
  text-align: left;
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    .rw-filter-input .rw-select .rw-btn-select {
      top: -15px;
    }
  }
`;

export const Dropdown = styled(DropdownList)`
  .rw-widget-picker {
    position: static;
  }
  .rw-widget-picker,
  .rw-dropdown-list-input {
    min-height: 40px;
  }
  .rw-widget {
    margin-top: 4px;
  }

  .rw-widget > .rw-widget-container {
    margin-top: 4px;
  }
  .rw-widget-container {
    border: solid 1px
      ${props =>
    props.active
      ? props.theme.color.primary
      : props.error
        ? props.theme.color.error
        : props.theme.color.border};
  }
  .rw-list-option {
    padding: 0.688em 0.688em;
    font-size: 16px;
    text-align: left;
    color: ${(p) => p.theme.color.text};
  }

  .rw-list-option.rw-state-selected,
  .rw-list-option.rw-state-selected:hover {
    background-color: #f5f5f9;
    border: 0;
    color: ${(p) => p.theme.color.text};
  }

  .rw-list-option.rw-state-focus,
  .rw-list-option.rw-state-focus:hover {
    border: 0;
    color: ${(p) => p.theme.color.text};
  }

  .rw-dropdown-list-input {
    box-sizing: border-box;
    padding: 10px 0px 10px 10px;
    text-align: left;
    font-size: 1rem;
    color: ${(p) => p.theme.color.text};
  }
  .rw-popup {
    margin-top: 8px;
    border-radius: 4px;
  }
  .rw-filter-input,
  .rw-input-reset,
  .rw-input,
  .rw-list-empty {
    font-family: 'HelveticaNeue', 'Helvetica Neue';
  }
  .rw-input-reset {
    font-size: 16px;
  }
  &.rw-state-disabled > .rw-widget-container,
  &.rw-state-disabled > .rw-widget-container:hover {
    cursor: default;
  }
  &.rw-state-disabled > .rw-widget-picker {
    background-color: ${p => p.theme.color.background};
    > * {
      opacity: 0.5;
      cursor: default;
    }
  }
`;

//──── multi select ──────────────────────────────────────────────────────────────────────
export const MS_CommonWrapper = styled.div`
  ${props =>
    props.haveData &&
    `.rw-list-empty {
    padding: 0;
    .rw-select-list {
      margin: 0;
      border: none;
      box-shadow: none;
    }
  }
  .rw-list-option {
    padding: 0;
    border: none;
  }
  .rw-select-list-label {
    padding: 0.688em 0.688em;
  }
  .rw-select-list-input {
    display: none;
  }
  .rw-dropdown-list-input {
    height: 2.5em;
  }`};
  ${props =>
    props.error &&
    `.rw-widget-container{
        border-color: ${props.theme.color.error}
    }`};
`;

export const MS_CheckBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  .icon {
    width: 1.15em;
    height: 1.15em;
    border: 1px solid
      ${props => (props.isChecked ? props.theme.color.primary : props.theme.color.border)};
    background-color: ${props => (props.isChecked ? props.theme.color.primary : 'white')};
    background-image: url(${whiteCheckMark});
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 0.1em;
    position: absolute;
    left: 0;
    background-size: 80%;
  }
  p {
    padding-left: 1.8em;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
  }
`;

//──── error messages ────────────────────────────────────────────────────────────────────
export const ErrorMessage = styled.div`
  color: ${props => props.theme.color.error};
  font-size: 12px;
  text-align: right;
  margin-top: 2px;
`;
